<template>
  <div>
    <div>
      <v-layout row justify-end class="mt-2">
        <v-flex xs12>
          <InputSearch
            class="mb-3"
            @clickAdvancedSearch="showSearchAdvanced = true"
            @clickSearch="onSearch()"
            @clearSearch="clearFilter"
            :search="filter"
            :isSearch="isSearch"
            :placeholder="
              'ค้นหา รหัสสมาชิก, ชื่อ-นามสกุล, อีเมล (ผู้ซื้อ), เบอร์ (ผู้ซื้อ), Tech Provider, ชื่อสินค้า'
            "
            :clearAdvancedSearch="clearAdvancedSearch"
            showClearAdvancedSearch
            showAdvancedSearch
          />
        </v-flex>
      </v-layout>

      <v-flex xs12>
        <div style="display: flex; align-items: center">
          <v-flex>
            <Typography h2 bold :label="$t('Coupon Report')" />
          </v-flex>
          <v-btn
            variant="outlined"
            :v-tooltip="$t('export')"
            @click="exportData"
            :loading="loading"
            icon
            color="#BECCDB"
            style="border-radius: 50% !important"
          >
            <img
              src="/static/img/exportfilter.png"
              alt
              class="responsive-img"
              style="height: 16px"
            />
          </v-btn>
          <exportxlsx ref="exbtn" :value="exData" style="display: none"></exportxlsx>
          <v-btn
            variant="outlined"
            v-tooltip="'เลือกคอลัมน์'"
            icon
            :loading="loading"
            :color="drawer ? '#0C2F53' : '#BECCDB'"
            @click.stop="drawer = !drawer"
            style="border-radius: 50% !important"
          >
            <img
              :src="`/static/img/${drawer ? 'filterColumnWhite.png' : 'filterColumnBlack.png'}`"
              alt
              class="responsive-img"
              style="height: 20px"
            />
          </v-btn>
        </div>
      </v-flex>
      <!-- 
      <v-layout row wrap justify-space-between class="ma-0">
        <v-flex>
          <div class="headline primary--text">{{ $t('Coupon Report') }}</div>
        </v-flex>
        <div style="align-self: center font-size: 18px" class="primary--text">
          Total
          {{
            this.showData && this.showData[0] && this.showData[0].total ? this.showData[0].total : 0
          }}
          <v-btn @click="exportData" :loading="loading" color="grey" outline>
            <i class="fas fa-file-export"></i>
            &nbsp;
            {{ $t('export') }}&nbsp;
          </v-btn>
          <exportxlsx ref="exbtn" :value="exData" style="display:none"></exportxlsx>
        </div>
      </v-layout> -->

      <v-layout class="my-5" justify-center v-if="loading">
        <v-progress-circular
          :size="100"
          :width="10"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
      <v-data-table
        v-else
        hide-actions
        :headers="headers"
        :items="showData"
        :pagination.sync="pagination"
        select-all
        item-key="name"
        class="elevation-1 cursor-5"
      >
        <template v-slot:headers="props">
          <tr style="background-color: #152d53; color: white">
            <th
              style="background-color: #152d53; color: yellow"
              v-for="header in props.headers"
              v-show="showColumn.includes(header.text) || header.text == ''"
              :key="header.text"
            >
              <div v-show="showColumn.includes(header.text)">{{ header.text }}</div>
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr class="py-3 depatable">
            <td
              class="text-xs-left"
              @click.stop="clickShowLog(props.item.couponid)"
              v-show="showColumn.includes('วันที่')"
              style="min-width: 147px"
            >
              {{ shotDate(props.item.timestamp) }}
            </td>
            <td
              class="text-xs-left"
              @click.stop="clickShowLog(props.item.couponid)"
              v-show="showColumn.includes('รหัสสมาชิก')"
            >
              {{ props.item.memberid }}
            </td>
            <td
              class="text-xs-left"
              @click.stop="clickShowLog(props.item.couponid)"
              v-show="showColumn.includes('เลขที่ใบสมัคร')"
              style="min-width: 196px"
            >
              {{ props.item.exid || '-' }}
            </td>
            <td
              class="text-xs-left"
              @click.stop="clickShowLog(props.item.couponid)"
              v-show="showColumn.includes('ชื่อ-นามสกุล')"
              style="min-width: 196px"
            >
              {{
                props.item.membername || props.item.coordinator_name || props.item.institute_name
              }}
            </td>
            <td
              class="text-xs-left"
              @click.stop="clickShowLog(props.item.couponid)"
              v-show="showColumn.includes('ชื่อหน่วยงาน')"
              style="min-width: 212px"
            >
              {{ props.item.institute_name }}
            </td>
            <td
              class="text-xs-left"
              @click.stop="clickShowLog(props.item.couponid)"
              v-show="showColumn.includes('อีเมล (ผู้ซื้อ)')"
              style="min-width: 208px"
            >
              {{ props.item.memberemail || '-' }}
            </td>
            <td
              class="text-xs-left"
              @click.stop="clickShowLog(props.item.couponid)"
              v-show="showColumn.includes('เบอร์ (ผู้ซื้อ)')"
              style="min-width: 168px"
            >
              {{ props.item.memberephone || '-' }}
            </td>
            <td
              class="text-xs-left"
              @click.stop="clickShowLog(props.item.couponid)"
              v-show="showColumn.includes('Tech Provider')"
              style="min-width: 233px"
            >
              {{ props.item.techproverdername }}
            </td>
            <td
              class="text-xs-left"
              @click.stop="clickShowLog(props.item.couponid)"
              v-show="showColumn.includes('ชื่อสินค้า')"
              style="min-width: 220px"
            >
              {{ props.item.productname }}
            </td>
            <td
              class="text-xs-left"
              @click.stop="clickShowLog(props.item.couponid)"
              v-show="showColumn.includes('ราคาสินค้า')"
              style="min-width: 168px"
            >
              {{ props.item.price }}
            </td>
            <td
              class="text-xs-left"
              @click.stop="clickShowLog(props.item.couponid)"
              v-show="showColumn.includes('หมวดหมู่เทคโนโลยี')"
              style="min-width: 280px"
            >
              {{ props.item.categoryname }}
            </td>
            <td
              class="text-xs-left"
              @click.stop="clickShowLog(props.item.couponid)"
              v-show="showColumn.includes('รหัสคูปอง')"
              style="min-width: 168px"
            >
              {{ props.item.code }}
            </td>
            <td
              class="text-xs-left"
              v-show="showColumn.includes('รายละเอียด')"
              style="min-width: 168px"
            >
              <div
                style="text-decoration: underline; width: 50px; color: #26588b"
                @click.stop="clickDetail(props.item.productid)"
              >
                ดูข้อมูล
              </div>
            </td>
            <td
              class="text-xs-left"
              @click.stop="showLog(props.item.couponid)"
              v-show="showColumn.includes('หน่วยร่วม')"
              style="min-width: 191px"
            >
              {{ props.item.agencyname }}
            </td>
            <td
              class="text-xs-left"
              @click.stop="showLog(props.item.couponid)"
              v-show="showColumn.includes('จังหวัด')"
              style="min-width: 155px"
            >
              {{ props.item.province }}
            </td>
            <td class="text-xs-left" v-show="showColumn.includes('สถานะ')" style="min-width: 155px">
              <Typography
                h5
                semiBold
                style="width: 100px"
                :label="props.item.status ? props.item.status : '-'"
              />
            </td>
          </tr>
        </template>
      </v-data-table>

      <v-dialog
        v-model="showLog"
        scrollable
        persistent
        max-width="500px"
        transition="dialog-transition"
      >
        <v-card class="pb-10">
          <div class="text-xs-right">
            <v-spacer></v-spacer>
            <v-btn flat icon small fab @click="showLog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <div class="headline primary--text mt-0 mb-4 ml-3">ประวัติการทำรายการ</div>
          <div v-if="loadLog"></div>
          <div v-else-if="logData && logData.length" class="ml-3 mr-3 mb-4">
            <!-- <div v-for="(item, index) in logData" :key="`log-${index}`">
              {{ item.id }}
            </div> -->
            <v-data-table
              hide-actions
              :headers="headersLog"
              :items="logData"
              :loading="loading"
              select-all
              item-key="name"
              class="elevation-1"
            >
              <template v-slot:headers="props">
                <tr style="background-color: #152d53; color: white">
                  <th
                    style="background-color: #152d53; color: yellow; text-align: center"
                    v-for="(header, k) in props.headers"
                    :key="header.text + k"
                  >
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <tr class="py-3 depatable">
                  <td class="text-xs-center">
                    {{ props.item.adminid }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.status }}
                  </td>
                  <td class="text-xs-center">
                    {{ fullDateTime(props.item.timestamp) }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
          <h4 class="mb-5 mt-4 text-xs-center" v-else>ไม่มีข้อมูล</h4>
        </v-card>
      </v-dialog>

      <v-navigation-drawer v-model="drawer" right fixed temporary style="top: 200px; padding: 20px">
        <v-list density="compact" nav>
          <v-flex xs12 style="display: flex; align-items: center; justify-content: space-between">
            <!-- <div class="color-darkBlue bold7 fs-20">เลือกคอลัมน์</div> -->
            <Typography h3 bold label="เลือกคอลัมน์" />
            <v-icon @click.stop="drawer = false">close</v-icon>
          </v-flex>
          <div style="display: flex">
            <v-flex xs10 class="mb-2 mt-2">
              <div
                style="width: 100%; display: flex; align-items: center"
                class="form-group has-search"
              >
                <div
                  style="width: 100%; display: flex; justify-content: flex-end; border-right: 0px"
                  class="form-control"
                >
                  <input
                    @change="changeSearchColumn"
                    type="search"
                    class="depainput rsu mb-0"
                    placeholder="Search"
                    name="search"
                    v-model="searchColumn"
                    style="border-radius: 0px; border-right: 0px"
                  />
                </div>
              </div>
            </v-flex>
            <v-flex xs2 class="mb-2 mt-2">
              <div
                class="pointer"
                style="
                  border: 1px solid #cfcfcf;
                  height: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  border-left: 0px;
                  border-right: 0px;
                  border-top-color: initial !important;
                  border-bottom-color: initial !important;
                "
              >
                <span
                  class="fa fa-times-circle form-control-feedback pointer"
                  style="color: #00000040"
                  @click="clearSearchColumn"
                ></span>
              </div>
            </v-flex>
            <v-flex xs2 class="mb-2 mt-2">
              <div
                class="pointer"
                style="
                  border: 1px solid #cfcfcf;
                  height: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  border-top-color: initial !important;
                  border-bottom-color: initial !important;
                "
              >
                <span
                  @click="changeSearchColumn"
                  class="fa fa-search form-control-feedback"
                  style="color: #bdbdbd"
                ></span>
              </div>
            </v-flex>
          </div>
          <div style="overflow: auto; height: 380px">
            <div
              class="mt-2"
              style="display: flex"
              v-for="item in this.column"
              @click="clickShowColumn(item)"
              :key="item"
            >
              <v-checkbox
                color="#0C2F53"
                style="display: flex; flex: none !important; margin-top: 0px; padding-top: 0px"
                v-model="showColumn.includes(item)"
                hide-details
                dense
              >
              </v-checkbox>
              <Typography h5 :label="item" />
            </div>
          </div>
        </v-list>
      </v-navigation-drawer>

      <v-dialog v-model="showSearchAdvanced" persistent width="500px">
        <v-card style="border-radius: 10px">
          <v-btn style="float: right" @click="showSearchAdvanced = false" icon
            ><v-icon>close</v-icon></v-btn
          >
          <div class="pa-4">
            <div style="display: flex">
              <i
                class="fa fa-filter color-darkBlue"
                style="font-size: 18px; display: flex; align-items: center"
                aria-hidden="true"
              ></i>
              <Typography h3 semiBold label="Advanced Search" class="pl-1" />
            </div>
            <div class="rsu">
              <v-layout row wrap>
                <v-flex xs12 class="mb-2 mt-2 pr-1">
                  <Typography class="pr-3" h5 label="สถานะ" />
                  <multiselect
                    class="mx-0 mx-sm-2"
                    v-model="filter.status"
                    :options="status"
                    label="label"
                    selectLabel
                    selectedLabel
                    placeholder="สถานะ"
                    :searchable="false"
                    deselect-label
                  >
                  </multiselect>
                </v-flex>
                <v-flex xs12 class="mb-2 mt-2 pr-1">
                  <Typography class="pr-3" h5 label="แคมเปญ" />
                  <multiselect
                    class="mr-0 mr-sm-2"
                    v-model="filter.campaign"
                    :options="campaign"
                    label="campaignname"
                    selectLabel
                    selectedLabel
                    placeholder="แคมเปญ"
                    :searchable="false"
                    deselect-label
                  >
                  </multiselect>
                </v-flex>
                <v-flex xs12 class="mb-2 mt-2 pr-1">
                  <Typography class="pr-3" h5 label="หน่วยร่วม" />
                  <multiselect
                    v-model="filter.agent"
                    :options="agencyList"
                    selectLabel
                    label="agencyname"
                    selectedLabel
                    placeholder="หน่วยร่วม"
                    :searchable="false"
                    deselect-label
                  ></multiselect>
                </v-flex>
                <v-flex xs12 class="mb-2 mt-2 pr-1">
                  <Typography class="pr-3" h5 label="จังหวัด" />
                  <multiselect
                    v-model="filter.province"
                    :options="province"
                    placeholder="จังหวัด"
                    :searchable="true"
                    deselect-label
                  ></multiselect>
                </v-flex>
                <v-flex xs12 class="mb-2 mt-2">
                  <Typography class="pr-3" h5 label="ชื่อสมาชิก" />
                  <div style="width: 100%" class="form-control">
                    <input
                      name="ชื่อสมาชิก"
                      placeholder="ชื่อสมาชิก"
                      v-model="filter.name"
                      type="text"
                      class="depainput rsu mb-0"
                    />
                  </div>
                </v-flex>
                <v-flex xs12 class="mb-2 mt-2">
                  <Typography class="pr-3" h5 label="รหัสสมาชิก" />
                  <div style="width: 100%" class="form-control">
                    <input
                      name="รหัสสมาชิก"
                      placeholder="รหัสสมาชิก"
                      v-model="filter.memberid"
                      type="text"
                      class="depainput rsu mb-0"
                    />
                  </div>
                </v-flex>
              </v-layout>
              <div class="pt-2" style="display: flex; justify-content: center">
                <Button
                  :loading="loading"
                  outline
                  :label="$t('Clear Search')"
                  @click="clearFilter()"
                />
                <Button :loading="loading" depressed :label="$t('Search')" @click="onSearch()" />
              </div>
            </div>
          </div>
        </v-card>
      </v-dialog>

      <Paginations
        @clickPagination="changepage"
        @sortPage="sortPage"
        :pageCount="pageCount"
        :numberPage="numberPage"
        :page="page"
      />
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import api from '@/api'
import moment from 'moment'
import province from '@/assets/js/province.js'
import config from '@/config'
import Exportxlsx from '@/components/elements/exportxlsx'
import InputSearch from '@/components/elements/InputSearch.vue'
import Typography from '@/components/elements/Typography.vue'
import Button from '@/components/elements/Button.vue'
import Paginations from '@/components/elements/Paginations.vue'

export default {
  components: {
    Multiselect,
    Exportxlsx,
    InputSearch,
    Typography,
    Button,
    Paginations
  },
  data() {
    return {
      isSearch: false,
      clearAdvancedSearch: false,
      showSearchAdvanced: false,
      drawer: false,
      searchColumn: '',
      agencyList: [],
      pagination: {
        sortBy: 'name',
        descending: false,
        rowsPerPage: 15,
        page: 1
      },
      filter: {
        text: '',
        status: null,
        campaign: null,
        province: null,
        agent: null,
        name: null,
        memberid: null,
        nameAll: null
      },
      headers: [
        { text: 'วันที่', align: 'left', value: 'date' },
        { text: 'รหัสสมาชิก', align: 'left', value: 'id' },
        { text: 'เลขที่ใบสมัคร', align: 'left', value: 'exid' },
        { text: 'ชื่อ-นามสกุล', align: 'left', value: 'buyer' },
        { text: 'ชื่อหน่วยงาน', align: 'left', value: 'institute' },
        { text: 'อีเมล (ผู้ซื้อ)', align: 'left', value: 'email' },
        { text: 'เบอร์ (ผู้ซื้อ)', align: 'left', value: 'phone' },
        { text: 'Tech Provider', align: 'left', value: 'techprovider' },
        { text: 'ชื่อสินค้า', align: 'left', value: 'productname' },
        { text: 'ราคาสินค้า', align: 'left', value: 'productprice' },
        { text: 'หมวดหมู่เทคโนโลยี', align: 'center', value: 'categoryname' },
        { text: 'รหัสคูปอง', align: 'left', value: 'couponcode' },
        { text: 'รายละเอียด', align: 'left', value: 'detail' },
        { text: 'หน่วยร่วม', align: 'left', value: 'agency' },
        { text: 'จังหวัด', align: 'left', value: 'province' },
        { text: 'สถานะ', align: 'left', value: 'status' }
      ],
      headersLog: [
        { text: 'Admin', align: 'center', value: 'admin' },
        { text: 'Status', align: 'center', value: 'status' },
        { text: 'Date', align: 'center', value: 'date' }
      ],
      column: [
        'วันที่',
        'รหัสสมาชิก',
        'เลขที่ใบสมัคร',
        'ชื่อ-นามสกุล',
        'ชื่อหน่วยงาน',
        'อีเมล (ผู้ซื้อ)',
        'เบอร์ (ผู้ซื้อ)',
        'Tech Provider',
        'ชื่อสินค้า',
        'ราคาสินค้า',
        'หมวดหมู่เทคโนโลยี',
        'รหัสคูปอง',
        'รายละเอียด',
        'หน่วยร่วม',
        'จังหวัด',
        'สถานะ'
      ],
      columnAll: [
        'วันที่',
        'รหัสสมาชิก',
        'เลขที่ใบสมัคร',
        'ชื่อ-นามสกุล',
        'ชื่อหน่วยงาน',
        'อีเมล (ผู้ซื้อ)',
        'เบอร์ (ผู้ซื้อ)',
        'Tech Provider',
        'ชื่อสินค้า',
        'ราคาสินค้า',
        'หมวดหมู่เทคโนโลยี',
        'รหัสคูปอง',
        'รายละเอียด',
        'หน่วยร่วม',
        'จังหวัด',
        'สถานะ'
      ],
      showColumn: [
        'วันที่',
        'รหัสสมาชิก',
        'เลขที่ใบสมัคร',
        'ชื่อ-นามสกุล',
        'ชื่อหน่วยงาน',
        'อีเมล (ผู้ซื้อ)',
        'เบอร์ (ผู้ซื้อ)',
        'Tech Provider',
        'ชื่อสินค้า',
        'ราคาสินค้า',
        'หมวดหมู่เทคโนโลยี',
        'รหัสคูปอง',
        'รายละเอียด',
        'หน่วยร่วม',
        'จังหวัด',
        'สถานะ'
      ],
      loading: false,
      data: [],
      showData: [],
      exData: [],
      exDataAll: [],
      campaign: [],
      page: 1,
      showLog: false,
      loadLog: false,
      logData: [],
      status: [
        {
          label: 'รอตรวจสอบ',
          value: 'รอตรวจสอบ'
        },
        {
          label: 'รอเอกสาร',
          value: 'รอเอกสาร'
        },
        {
          label: 'แก้ไขเอกสาร',
          value: 'แก้ไขเอกสาร'
        },
        {
          label: 'อนุมัติ',
          value: 'อนุมัติ'
        },
        {
          label: 'ไม่อนุมัติ',
          value: 'ไม่อนุมัติ'
        },
        {
          label: 'ยกเลิก',
          value: 'ยกเลิก'
        },
        {
          label: 'หมดอายุ',
          value: 'หมดอายุ'
        }
      ],
      page: 1,
      pageTotal: 0,
      rowsPerPage: 15,
      numberPage: {
        page: undefined
      }
    }
  },
  // watch: {
  //   showData: {
  //     immediate: true,
  //     handler(showData) {
  //       if (showData && showData.length) {
  //         this.setEx()
  //       }
  //     }
  //   }
  // },
  computed: {
    pageCount() {
      if (this.pageTotal !== 0) {
        let count = Math.ceil(this.pageTotal / this.rowsPerPage)
        return count
      } else {
        return 0
      }
    },
    limitCom() {
      return this.rowsPerPage
    },
    offsetCom() {
      return this.page ? this.page * this.rowsPerPage - this.rowsPerPage : this.rowsPerPage
    },
    province() {
      return province
    },
    config() {
      return config
    },
    pageCount() {
      if (this.showData && this.showData[0] && this.showData[0].total) {
        let count = Math.ceil(this.showData[0].total / this.rowsPerPage)
        return count
      } else {
        return 0
      }
    },
    limitCom() {
      return this.rowsPerPage
    },
    offsetCom() {
      return this.page ? this.page * this.rowsPerPage - this.rowsPerPage : this.rowsPerPage
    }
  },
  async mounted() {
    await this.getAgency()
    await this.setupData()
  },
  methods: {
    async onSearch() {
      this.isSearch = true
      this.loading = true
      this.page = 1
      await this.setupData()
      this.showSearchAdvanced = false
      this.loading = false
    },
    changeSearchColumn(name) {
      let outputResult
      if (name.target._value !== '') {
        outputResult = this.columnAll.filter(item => {
          return item.toLowerCase().indexOf(name.target._value.toLowerCase()) !== -1
        })
      } else {
        outputResult = this.columnAll.filter(item => {
          return item
        })
      }
      this.column = outputResult
    },
    clearSearchColumn() {
      this.searchColumn = ''
      this.column = this.columnAll
    },
    clickShowColumn(item) {
      if (this.showColumn.includes(item)) {
        var filterCheckbox = this.showColumn.filter(result => result !== item)
        this.showColumn = filterCheckbox
      } else {
        this.showColumn.push(item)
      }
    },
    async clickShowLog(id) {
      this.showLog = true
      this.loadLog = true
      let resData = await api.getCouponLog(id)
      this.loadLog = false
      if (resData) {
        this.logData = resData
      }
    },
    async changepage(pages) {
      this.page = parseInt(pages)
      this.numberPage.page = undefined
      await this.getCouponReport()
    },
    async sortPage(pages) {
      let count = Math.ceil(this.pageTotal / this.rowsPerPage)
      if (pages == '' || Number(pages <= 0) || pages > Number(count)) return
      if (pages) {
        this.page = parseInt(pages)
        await this.getCouponReport()
      }
    },
    async exportData() {
      this.loading = true
      await this.getExData()
      await this.setEx()
      this.$refs.exbtn.exportxlsx()
      this.loading = false
    },
    async getAgency() {
      let resData = await api.getAgency()
      if (resData && resData.responsecode == 200) {
        if (
          this.$store.state.privilege.role == 'agency' &&
          this.$store.state.privilege.agency !== undefined && 
          this.$store.state.privilege.agency.length !== 0
        ) {
          this.agencyList = this.$store.state.privilege.agency
        } else {
          this.agencyList = resData.data
        }
      }
    },
    async setupData() {
      await this.getCouponReport()
      await this.getCampaign()
    },
    async getCouponReport() {
      this.loading = true
      let params = {}
      if (this.filter.status) {
        Object.assign(params, { status: this.filter.status.value })
      }
      if (this.filter.campaign) {
        Object.assign(params, { campaignId: this.filter.campaign.id })
      }
      if (this.filter.agent) {
        Object.assign(params, { agencylistid: this.filter.agent.id.toString() })
      }
      if (this.filter.province) {
        Object.assign(params, { province: this.filter.province })
      }
      if (this.filter.name) {
        Object.assign(params, { name: this.filter.name })
      }
      if (this.filter.memberid) {
        Object.assign(params, { memberid: parseInt(this.filter.memberid) })
      }
      if (this.filter.nameAll) {
        Object.assign(params, { nameAll: this.filter.nameAll })
      }

      params.limit = this.limitCom
      params.offset = this.offsetCom

      if (!this.filter.agent) {
        let agencylistid = this.agencyList.map(agency => {
          return agency.id
        })
        agencylistid = agencylistid.join(',')
        params.agencylistid = agencylistid
      }

      this.data = await api.getCouponReport(params)

      this.showData = this.data.data ? this.data.data : []
      this.pageTotal = this.data.total ? this.data.total : []
      this.showSearchAdvanced = false
      this.loading = false
    },
    async getExData() {
      let params = {}

      if (this.filter.status) {
        Object.assign(params, { status: this.filter.status.value })
      }
      if (this.filter.campaign) {
        Object.assign(params, { campaignId: this.filter.campaign.id })
      }
      if (this.filter.agent) {
        Object.assign(params, { agencylistid: this.filter.agent.id.toString() })
      }
      if (this.filter.province) {
        Object.assign(params, { province: this.filter.province })
      }
      if (this.filter.name) {
        Object.assign(params, { name: this.filter.name })
      }
      if (this.filter.memberid) {
        Object.assign(params, { memberid: parseInt(this.filter.memberid) })
      }
      if (this.filter.nameAll) {
        Object.assign(params, { nameAll: this.filter.nameAll })
      }
      if (this.filter.exid) {
        Object.assign(params, { exid: this.filter.exid })
      }

      if (!this.filter.agent) {
        let agencylistid = this.agencyList.map(agency => {
          return agency.id
        })
        agencylistid = agencylistid.join(',')
        params.agencylistid = agencylistid
      }

      this.data = await api.getCouponReport(params)
      this.exDataAll = this.data.data ? this.data.data : []
    },
    async getCampaign() {
      this.campaign = await api.getCampaign()
    },
    shotDate(input) {
      return moment(input).format('DD/MM/YYYY')
    },

    fullDateTime(input) {
      return moment(input).format('DD/MM/YYYY HH:mm')
    },
    setEx() {
      let ex = []
      this.exDataAll.forEach(ele => {
        let obj = {
          วันที่: moment(ele.timestamp).format('DD/MM/YYYY'),
          เลขสมาชิก: ele.memberid,
          เลขที่ใบสมัคร: ele.exid,
          ผู้ซื้อ: ele.membername,
          หน่วยงาน: ele.institute_name,
          'ผู้ขาย (Tech Provider)': ele.techproverdername,
          ชื่อสินค้า: ele.productname,
          ราคา: ele.price,
          รหัสคูปอง: ele.code,
          หน่วยร่วม: ele.agencyname,
          สถานะ: ele.status
        }
        ex.push(obj)
      })
      this.exData = ex
    },
    async clearFilter() {
      this.filter = {
        text: '',
        status: null,
        campaign: null,
        province: null,
        name: null,
        memberid: null,
        nameAll: null
      }

      this.isSearch = false
      this.loading = true
      this.page = 1
      await this.getCouponReport()
      this.showSearchAdvanced = false
      this.loading = false
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    clickDetail(id) {
      window.open(`${config.techhuntUrl}product?id=${id}`)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/techhuntCouponreport/main.vue